import { Component, OnInit } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';

@Component({
  selector: 'dialog-product-images',
  templateUrl: './dialog-product-images.component.html',
  styleUrls: ['./dialog-product-images.component.scss']
})
export class DialogProductImagesComponent implements OnInit {
  
  productImages: Array<string>;

  constructor(
    protected dialogRef: NbDialogRef<DialogProductImagesComponent>,
  ) { }

  ngOnInit(): void {
    this.dialogRef.onBackdropClick.subscribe(() => {
      this.dialogRef.close();
    });
  }

}
